import { useEffect } from 'react';
import { Upload } from 'src/apis/monolith/types';
import { isServerError, useAxios } from 'src/hooks/use-axios';

type Options = {
  rawDataId: number | string;
};

export function useUpload({ rawDataId }: Options) {
  const upload = useAxios(
    (axios, signal, id: number | string) =>
      axios.request<Upload>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/uploads/${id}`,
        method: 'GET',
        validateStatus(status) {
          // if we get 204 the data of the uploaded product is no longer available
          // this can be treated like a "410 Gone" error
          if (status === 204) return false;

          return status >= 200 && status < 300; // default
        },
      }),
    {
      neededOnPageLoad: true,
      onError(error) {
        if (isServerError(error) && error.response.status === 204) {
          return error;
        } else {
          throw error;
        }
      },
    }
  );

  useEffect(() => {
    upload.execute(rawDataId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawDataId]);

  return upload;
}

export type UploadRequest = ReturnType<typeof useUpload>;
